const MonitorReducerEnhancer = (createStore: any) => (
    reducer: any,
    initialState: any,
    enhancer: any
) => {
    const monitoredReducer = (state: any, action: any) => {
        return reducer(state, action)
    }
    return createStore(monitoredReducer, initialState, enhancer)
}
export default MonitorReducerEnhancer